export default "__VITE_ASSET__DxBSACov__"